// Textos del panel de la flota de taxi/VTC (`/fleet/:fleetId/…`, fase 3 de
// docs/flotas-drivers). Se registran en AppComponent y se fusionan con
// drivers-fleet/es.ts.
export const locale = {
  lang: 'es',
  data: {
    DRIVERS_FLEET: {
      PANEL: {
        ACTIONS: 'Acciones',
        EDIT: 'Editar',
        SAVED: 'Guardado',
        COPY: 'Copiar',
        COPIED: 'Copiado',
        DATE_FROM: 'Desde',
        DATE_TO: 'Hasta',
        RANGE_INVALID: 'La fecha «Desde» no puede ser posterior a «Hasta».',
        GENERIC_ERROR: 'No se ha podido completar la acción. Inténtalo de nuevo.',
        WEEKDAY: { 1: 'Lunes', 2: 'Martes', 3: 'Miércoles', 4: 'Jueves', 5: 'Viernes', 6: 'Sábado', 7: 'Domingo' },
        OVERVIEW: {
          LOAD_ERROR: 'No se ha podido cargar el resumen.',
          KPI_FEE: 'Cuota al pasajero',
          KPI_FEE_NOTE: 'No se descuenta de tu facturación',
          ALERTS_TITLE: 'Necesita tu atención',
          START_TITLE: 'Primeros pasos',
          START_SUB: '{{done}} de {{total}} hechos. Con todo listo, tus conductores pueden empezar a trabajar.',
          START_GO: 'Empezar',
          CHART_TITLE: 'Viajes por día',
          CHART_Q: '¿Cuántos viajes han hecho tus conductores en los últimos {{days}} días?',
          CHART_EMPTY: 'Todavía no hay viajes en este periodo.',
          TIP_TRIPS: 'Viajes',
          TOP_EMPTY: 'Sin viajes en este periodo.',
          TOP_TRIPS: '{{count}} viajes',
        },
        DRIVERS: {
          TABS_ARIA: 'Estado de los conductores',
          COL_DRIVER: 'Conductor',
          COL_DOCUMENTS: 'Documentos',
          DOCS_TOOLTIP:
            'Aprobados: {{approved}} · En revisión: {{inReview}} · Rechazados: {{rejected}} · Pendientes: {{pending}} · Caducados: {{expired}}',
          EMPTY_FILTERED: 'Ningún conductor coincide con la búsqueda.',
          LOAD_ERROR: 'No se han podido cargar los conductores.',
          SHOWING: 'Mostrando {{shown}} de {{total}} conductores',
          PER_PAGE: '{{count}} por página',
          PER_PAGE_ARIA: 'Conductores por página',
          ACCEPT: 'Aceptar',
          ACCEPTING: 'Aceptando…',
          ACCEPT_TITLE: 'Aceptar al conductor',
          ACCEPTED_TITLE: '{{name}} ya forma parte de la flota',
          ACCEPT_ERROR: 'No se ha podido aceptar la solicitud.',
          EMPLOYMENT_LABEL: 'Cómo trabaja para la flota',
          EMPLOYMENT_REQUIRED: 'Elige si es autónomo o asalariado.',
          SELF_EMPLOYED_HINT: 'Factura sus viajes y se queda un % de lo que cobra.',
          SALARIED_HINT: 'Trabaja con contrato: la flota cobra los viajes íntegros.',
          SHARE_LABEL: '% que se queda el conductor',
          SHARE_PLACEHOLDER: 'El de la flota',
          SHARE_HINT: 'Si lo dejas vacío, se aplica el reparto por defecto de la flota.',
          SHARE_INVALID: 'Pon un porcentaje entre 0 y 100.',
          REJECT: 'Rechazar',
          REJECTING: 'Rechazando…',
          REJECTED_DONE: 'Rechazada',
          REJECT_TITLE: 'Rechazar la solicitud de {{name}}',
          REJECT_TEXT: 'No entrará en la flota. Puede volver a pedirlo con el código.',
          REJECT_PLACEHOLDER: 'Motivo (opcional, lo verá el conductor)',
          REJECT_ERROR: 'No se ha podido rechazar la solicitud',
          REGENERATE: 'Cambiar código',
          REGENERATING: 'Cambiando…',
          REGENERATED: 'Cambiado',
          REGENERATE_TITLE: 'Cambiar el código de flota',
          REGENERATE_TEXT: 'El código actual deja de valer. Los conductores ya vinculados no se ven afectados.',
          REGENERATE_ERROR: 'No se ha podido cambiar el código',
        },
        DRIVER: {
          TITLE: 'Ficha del conductor',
          LOAD_ERROR: 'No se ha podido cargar el conductor.',
          DOCS_TITLE: 'Documentos',
          DOCS_SUB: 'Los revisa WAIIS. Aquí solo ves su estado; el conductor los sube desde la app.',
          DOCS_EMPTY: 'Todavía no ha subido ningún documento.',
          REMOVE: 'Desvincular',
          REMOVING: 'Desvinculando…',
          REMOVED: 'Desvinculado',
          REMOVE_TITLE: 'Desvincular a {{name}}',
          REMOVE_TEXT: 'Dejará de trabajar para la flota y se le quitará de todos sus turnos.',
          REMOVE_ERROR: 'No se ha podido desvincular al conductor',
          REMOVED_SHIFTS: 'Conductor desvinculado. Se han liberado {{count}} franjas de turno.',
        },
        VEHICLES: {
          ADD: 'Añadir vehículo',
          TABS_ARIA: 'Estado de los vehículos',
          TAB_ALL: 'Todos',
          COL_PLATE: 'Matrícula',
          COL_SEATS: 'Plazas',
          LICENSE_taxi: 'Nº de licencia municipal',
          LICENSE_vtc: 'Nº de autorización VTC',
          EMPTY: 'Todavía no has dado de alta ningún vehículo.',
          EMPTY_FILTERED: 'Ningún vehículo coincide con los filtros.',
          LOAD_ERROR: 'No se han podido cargar los vehículos.',
          SHOWING: 'Mostrando {{shown}} de {{total}} vehículos',
          PER_PAGE: '{{count}} por página',
          PER_PAGE_ARIA: 'Vehículos por página',
          BRAND: 'Marca',
          MODEL: 'Modelo',
          PLATE_INVALID: 'La matrícula no es válida.',
          DELETE: 'Dar de baja',
          DELETING: 'Dando de baja…',
          DELETED: 'Dado de baja',
          DELETE_TITLE: 'Dar de baja el {{plate}}',
          DELETE_TEXT: 'El vehículo sale de la flota y se quita de todos los turnos.',
          DELETE_ERROR: 'No se ha podido dar de baja el vehículo',
          DELETED_SHIFTS: 'Vehículo dado de baja. Se han liberado {{count}} franjas de turno.',
        },
        SHIFTS: {
          SAVE: 'Guardar turnos',
          DISCARD: 'Descartar cambios',
          LOAD_ERROR: 'No se han podido cargar los turnos.',
          SAVE_ERROR: 'No se han podido guardar los turnos.',
          LOCKED: 'Para organizar los turnos hace falta al menos un vehículo y un conductor aceptado.',
          FREE: 'libre',
          OUTDATED_TITLE: 'Los turnos han cambiado',
          RELOAD: 'Volver a cargar',
        },
        DOCUMENTS: {
          LOAD_ERROR: 'No se han podido cargar los documentos.',
          COMPANY: 'Empresa',
          URGENCY: {
            in_review: 'En revisión',
            valid: 'Al día',
          },
          EMPTY: 'Todavía no hay vehículos en la flota.',
          UPLOADED_AT: 'Subido el {{date}}',
          VIEW_ERROR: 'No se ha podido abrir el documento.',
        },
        SETTLEMENTS: {
          EXPORT: 'Exportar CSV',
          INFO_TITLE: 'De momento, solo informativo',
          SUMMARY_ERROR: 'No se ha podido cargar el resumen.',
          NEXT_PAYOUT: 'Próxima liquidación',
          DEFAULT_SHARE: 'Reparto por defecto',
          MOVEMENTS_TITLE: 'Movimientos',
          MOVEMENTS_SUB:
            'Cada fila es dinero que ya se ha movido. La cuota al pasajero (solo en servicios de la app WAIIS; tus clientes propios van a 0 €) se paga encima de la tarifa: tú cobras la tarifa íntegra.',
          TYPE_ALL: 'Todos los tipos',
          TYPE_ARIA: 'Tipo de movimiento',
          TYPE: {
            trip_earning: 'Viaje',
            driver_share: 'Parte del conductor',
            payout: 'Liquidación',
            adjustment: 'Ajuste',
          },
          DRIVER_ALL: 'Todos los conductores',
          DRIVER_ARIA: 'Conductor',
          COL_DATE: 'Fecha',
          COL_TYPE: 'Tipo',
          COL_DRIVER: 'Conductor',
          COL_DESCRIPTION: 'Descripción',
          COL_FARE: 'Tarifa',
          COL_COMMISSION: 'Cuota',
          COL_PASSENGER: 'Paga el pasajero',
          COL_AMOUNT: 'Importe flota',
          COMMISSION_TOOLTIP: 'La paga el pasajero además de la tarifa, solo en los servicios que llegan por la app WAIIS. No se descuenta de lo que cobra la flota.',
          EMPTY: 'No hay movimientos en este periodo.',
          LOAD_ERROR: 'No se han podido cargar los movimientos.',
          SHOWING: 'Mostrando {{shown}} de {{total}} movimientos',
          PER_PAGE: '{{count}} por página',
          PER_PAGE_ARIA: 'Movimientos por página',
        },
        REPORTS: {
          EXPORT_ERROR: 'No se ha podido descargar el informe.',
          COL_TRIPS: 'Viajes',
          COL_HOURS: 'Horas conectado',
          COL_FARE: 'Facturación',
          COL_ACCEPTANCE: 'Aceptación',
          COL_RATING: 'Valoración',
          EMPTY: 'Sin actividad en este periodo.',
          LOAD_ERROR: 'No se ha podido cargar el rendimiento.',
          SHOWING: 'Mostrando {{shown}} de {{total}} conductores',
          PER_PAGE: '{{count}} por página',
          PER_PAGE_ARIA: 'Conductores por página',
        },
        TEAM: {
          INVITE: 'Invitar a alguien',
          INVITE_SUB: 'Le llegará un correo para entrar al panel.',
          TITLE: 'Personas con acceso',
          SUB: 'Quién entra al panel de la flota y qué puede hacer.',
          COL_MEMBER: 'Persona',
          COL_ROLE: 'Rol',
          STATUS_invited: 'Invitado',
          STATUS_active: 'Activo',
          EMPTY: 'Todavía no hay nadie en el equipo.',
          LOAD_ERROR: 'No se ha podido cargar el equipo.',
          EMAIL: 'Correo electrónico',
          EMAIL_INVALID: 'Escribe un correo válido.',
          SEND_INVITE: 'Enviar invitación',
          INVITED_TITLE: 'Invitación enviada a {{email}}',
          CHANGE_ROLE: 'Cambiar el rol',
          LAST_OWNER: 'La flota tiene que tener al menos un propietario.',
          REMOVE: 'Quitar del equipo',
          REMOVING: 'Quitando…',
          REMOVED: 'Quitado',
          REMOVE_TITLE: 'Quitar a {{name}} del equipo',
          REMOVE_TEXT: 'Dejará de tener acceso al panel de la flota.',
          REMOVE_TEXT_INVITED: 'La invitación dejará de valer.',
          REMOVE_ERROR: 'No se ha podido quitar del equipo',
        },
        SETTINGS: {
          LOAD_ERROR: 'No se han podido cargar los ajustes.',
          COMPANY_TITLE: 'Datos de la flota',
          COMPANY_SUB: 'Cómo se llama y a qué correo te escribimos.',
          NAME: 'Nombre de la flota',
          CONTACT_EMAIL: 'Correo de contacto',
          MODE: 'Tipo de servicio',
          LOCKED_FIELDS: 'El tipo de servicio y la región no se pueden cambiar. Si lo necesitas, escribe a soporte.',
          BILLING_SUB: 'A nombre de quién facturamos.',
          BILLING_WARN: 'Al guardar, los datos vuelven a revisión. Mientras tanto se sigue facturando con los anteriores.',
          BILLING_IN_REVIEW: 'WAIIS está revisando los últimos cambios. Podrás editarlos cuando termine.',
          SLOTS_TITLE: 'Franjas de turno',
          SLOTS_SUB: 'Iguales para toda la flota; la de noche puede pasar de medianoche. Si cambias las horas, se aplican desde la semana que viene.',
          SLOT_START: 'Empieza',
          SLOT_END: 'Termina',
          SLOT_INVALID: 'Pon la hora de inicio y de fin, y que no sean iguales.',
          CROSSES_MIDNIGHT: 'Pasa de medianoche',
          NOTIFICATIONS_TITLE: 'Avisos por correo',
          NOTIFICATIONS_SUB: 'Se envían a {{email}}.',
          NOTIFY_documentExpiring: 'Un documento caduca pronto',
          NOTIFY_documentRejected: 'WAIIS rechaza un documento',
          NOTIFY_driverRequests: 'Un conductor pide entrar',
          NOTIFY_weeklySettlement: 'Resumen semanal de liquidaciones',
        },
      },
    },
    PAGE_HEADER: {
      FLEET_DRIVERS: 'Acepta a los conductores que se vinculan con tu código de flota y consulta el estado de sus documentos.',
      FLEET_VEHICLES: 'Los coches de la flota, su licencia y sus documentos.',
      FLEET_DOCUMENTS: 'El estado y la caducidad de los documentos de la empresa y de los vehículos.',
      FLEET_SETTLEMENTS: 'Lo que ha facturado la flota y el reparto de cada viaje.',
      FLEET_REPORTS: 'Los informes de viajes, conductores y liquidaciones para descargar.',
      FLEET_TEAM: 'Las personas que gestionan la flota contigo y su rol.',
      FLEET_SETTINGS: 'Datos de la flota, facturación, franjas de turno y avisos.',
    },
  },
};
